export const TEST_ID = 'flightPlannerStats';

export const STAT_COVERAGE_AREA_TEST_ID = 'flightPlannerStatsCoverageArea';

export const STAT_FLIGHT_TIME_TEST_ID = 'flightPlannerStatsFlightTime';

export const STAT_PASSES_TEST_ID = 'flightPlannerStatsPasses';

export const STAT_PRODUCTIVE_TEST_ID = 'flightPlannerStatsProductive';

export const STAT_TOTAL_DISTANCE_TEST_ID = 'flightPlannerStatsTotalDistance';

export const STAT_TURNS_TEST_ID = 'flightPlannerStatsTurns';

export const UNIT_ACRES = 'ac';

export const UNIT_MILES = 'mi';

export const UNIT_MIN = 'min';

export const UNIT_PERCENT = '%';

export const AREA_DECIMAL_PLACES = 2;

export const COVERAGE_FRACTION_PERCENT_MULTIPLIER = 100;

export const MILES_DECIMAL_PLACES = 2;

export const PERCENT_DECIMAL_PLACES = 1;
